var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('legend',{staticClass:"legend-title"},[_vm._v(" Request Settings ")]),_c('ProgrammaticTargetRequestSettings',{attrs:{"programmatic-target":_vm.programmaticTarget,"readonly":""},on:{"update":_vm.updateTargetDetails}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }